import React from "react";

/**
 * React component for rendering a tab character as whitespace.
 *
 * The `Tab` component represents a tab character used for indentation within text or code. It renders
 * three consecutive non-breaking space characters ("&nbsp;&nbsp;&nbsp;"), typically used to create
 * visual indentation in text or code.
 *
 * @return {JSX.Element} The rendered component representing a tab character as whitespace.
 */

const Tab = () => {
  return <>&nbsp;&nbsp;&nbsp;</>;
};

export default Tab;
